"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var core_1 = require("@aws-amplify/core");
require("@aws-amplify/ui/dist/style.css");
var AmplifyUI = require("@aws-amplify/ui");
var Amplify_UI_Theme_1 = require("./Amplify-UI-Theme");
var react_select_1 = require("react-select");
// Reactstrap imports (Bootstrap)
var reactstrap_1 = require("reactstrap");
// Material-ui import (Material)
var core_2 = require("@material-ui/core/");
var Error_1 = require("@material-ui/icons/Error");
var Close_1 = require("@material-ui/icons/Close");
function MUToast(props) {
    return (React.createElement(core_2.Snackbar, __assign({}, props),
        React.createElement(core_2.SnackbarContent, { style: {
                color: '#fff',
                backgroundColor: '#f44336',
            }, message: React.createElement("span", { style: {
                    display: 'flex',
                    alignItems: 'center',
                } },
                React.createElement(Error_1.default, { style: {
                        opacity: 0.9,
                        marginRight: '8px',
                    } }),
                props.message), action: [
                React.createElement(core_2.IconButton, { key: "close", color: "inherit", onClick: props.onClose },
                    React.createElement(Close_1.default, null)),
            ] })));
}
// Material Utility Components
var MUContainer = function (props) {
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.container);
    var p = core_1.JS.objectLessAttributes(props, 'theme');
    return (React.createElement(core_2.Grid, __assign({ container: true }, p, { style: style }),
        React.createElement(core_2.CssBaseline, null),
        props.children));
};
var MUCol = function (props) {
    var p = core_1.JS.objectLessAttributes(props, ['theme', 'uiFramework', 'hideLogo', 'size', 'block']);
    return (React.createElement(core_2.Grid, __assign({ item: true }, p), props.children));
};
var MUSelect = function (props) {
    var p = core_1.JS.objectLessAttributes(props, ['theme', 'uiFramework', 'hideLogo', 'size', 'block']);
    return (React.createElement(core_2.TextField, __assign({}, p, { margin: "normal", variant: "outlined", fullWidth: true, style: props.style, select: true, SelectProps: {
            native: true,
        } }), props.children));
};
// Bootstrap Utility Components
var RSSelect = function (props) {
    var p = core_1.JS.objectLessAttributes(props, ['theme', 'uiFramework', 'hideLogo']);
    return (React.createElement(reactstrap_1.Input, __assign({ type: "select" }, p), props.children));
};
exports.Container = function (props) {
    var uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.container);
    var removeProps = ['theme', 'uiFramework', 'hideLogo'];
    var p = {};
    if (uiFramework === "material") {
        removeProps.push('size', 'block');
    }
    p = core_1.JS.objectLessAttributes(props, removeProps);
    if (uiFramework === "bootstrap") {
        return exports.beforeAfter(React.createElement(reactstrap_1.Container, __assign({}, p, { fluid: true, className: "px-0", style: style }), props.children));
    }
    if (uiFramework === "material") {
        return exports.beforeAfter(React.createElement(MUContainer, __assign({}, p, { theme: theme, style: style }), props.children));
    }
    return exports.beforeAfter(React.createElement("div", __assign({}, p, { className: AmplifyUI.container, style: style }), props.children));
};
exports.Option = function (props) {
    var uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.option);
    var removeProps = ['theme', 'uiFramework', 'hideLogo'];
    var p = {};
    if (uiFramework === "material") {
        removeProps.push('size', 'block');
    }
    p = core_1.JS.objectLessAttributes(props, removeProps);
    // if (uiFramework === "material") {
    //     return beforeAfter(
    //         <MUMenuItem {...p} style={style}>
    //             {props.label}
    //         </MUMenuItem>
    //     )
    // }
    return exports.beforeAfter(React.createElement("option", __assign({}, p, { style: style }), props.label));
};
exports.FormContainer = function (props) {
    var uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    if (uiFramework === "bootstrap") {
        return exports.beforeAfter(React.createElement(reactstrap_1.Row, { className: "justify-content-center", noGutters: true, style: theme.formContainer }, props.children));
    }
    if (uiFramework === "material") {
        return exports.beforeAfter(React.createElement(React.Fragment, null, props.children));
    }
    return exports.beforeAfter(React.createElement("div", { className: AmplifyUI.formContainer, style: theme.formContainer }, props.children));
};
exports.Card = function (props) {
    var uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var formCardStyle = exports.propStyle(props, theme.formCard);
    var formSectionStyle = exports.propStyle(props, theme.formSection);
    if (uiFramework === "bootstrap") {
        return (React.createElement(reactstrap_1.Card, { style: formCardStyle },
            React.createElement(reactstrap_1.CardBody, null, props.children)));
    }
    if (uiFramework === "material") {
        return (React.createElement(core_2.Card, { style: formCardStyle },
            React.createElement(core_2.CardContent, null, props.children)));
    }
    return (React.createElement("div", { className: AmplifyUI.formSection, style: formSectionStyle }, props.children));
};
exports.FormSection = function (props) {
    var uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var backgroundImageStyles = exports.propStyle(props, theme.backgroundImage);
    if (uiFramework === "bootstrap") {
        return (React.createElement(exports.FormContainer, { theme: theme, uiFramework: uiFramework },
            backgroundImageStyles.backgroundImage ?
                React.createElement(reactstrap_1.Col, { sm: "4", md: "7", className: "d-none d-sm-block", style: backgroundImageStyles })
                : null,
            exports.beforeAfter(React.createElement(reactstrap_1.Col, { xs: "12", sm: "8", md: "5" },
                React.createElement(exports.Card, { theme: theme, uiFramework: uiFramework }, props.children)))));
    }
    if (uiFramework === "material") {
        return (React.createElement(exports.FormContainer, { theme: theme, uiFramework: uiFramework },
            backgroundImageStyles.backgroundImage ?
                React.createElement(MUCol, { theme: theme, xs: false, sm: 4, md: 7, style: backgroundImageStyles })
                : null,
            exports.beforeAfter(React.createElement(MUCol, { theme: theme, xs: 12, sm: 8, md: 5, component: core_2.Paper, elevation: 6, square: true },
                React.createElement(exports.Card, { theme: theme, uiFramework: uiFramework }, props.children)))));
    }
    return (React.createElement(exports.FormContainer, { theme: theme, uiFramework: uiFramework }, exports.beforeAfter(React.createElement(exports.Card, { theme: theme, uiFramework: uiFramework }, props.children))));
};
exports.SectionHeader = function (props) {
    var uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var hideLogo = props.hideLogo || false;
    var style = exports.propStyle(props, theme.sectionHeader);
    var logoImageStyle = exports.propStyle(props, theme.logoImage);
    var removeProps = ['theme', 'uiFramework', 'hideLogo'];
    var p = {};
    if (uiFramework === "material") {
        removeProps.push('size', 'block');
    }
    p = core_1.JS.objectLessAttributes(props, removeProps);
    if (uiFramework === "bootstrap") {
        return exports.beforeAfter(React.createElement("div", __assign({}, p, { style: style }),
            !hideLogo && (logoImageStyle.logo && React.createElement("img", { src: logoImageStyle.logo, style: logoImageStyle, alt: "app logo" })),
            React.createElement(exports.SectionHeaderContent, { theme: theme },
                React.createElement("h3", null, props.children),
                props.hint &&
                    React.createElement("div", { className: AmplifyUI.sectionHeaderHint }, props.hint))));
    }
    if (uiFramework === "material") {
        return exports.beforeAfter(React.createElement("div", __assign({}, p, { style: __assign(__assign({}, style), { marginBottom: 10 }) }),
            !hideLogo && (React.createElement("img", { src: logoImageStyle.logo, style: logoImageStyle, alt: "app logo" })),
            React.createElement(exports.SectionHeaderContent, { theme: theme },
                React.createElement("h3", null, props.children),
                props.hint &&
                    React.createElement("div", { className: AmplifyUI.sectionHeaderHint }, props.hint))));
    }
    return exports.beforeAfter(React.createElement("div", __assign({}, p, { className: AmplifyUI.sectionHeader, style: style }),
        React.createElement(exports.SectionHeaderContent, { theme: theme },
            props.children,
            props.hint &&
                React.createElement("div", { className: AmplifyUI.sectionHeaderHint }, props.hint))));
};
exports.SectionHeaderContent = function (props) {
    var uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.sectionHeaderContent);
    if (uiFramework === "bootstrap") {
        return exports.beforeAfter(React.createElement("span", { style: style }, props.children));
    }
    if (uiFramework === "material") {
        return exports.beforeAfter(React.createElement("span", { style: style }, props.children));
    }
    return exports.beforeAfter(React.createElement("span", { className: AmplifyUI.sectionHeaderContent, style: style }, props.children));
};
exports.SectionFooter = function (props) {
    var uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.sectionFooter);
    var removeProps = ['theme', 'uiFramework', 'hideLogo'];
    var p = {};
    if (uiFramework === "material") {
        removeProps.push('size', 'block');
    }
    p = core_1.JS.objectLessAttributes(props, removeProps);
    if (uiFramework === "bootstrap") {
        return exports.beforeAfter(React.createElement(reactstrap_1.Row, __assign({}, p, { style: style }), props.children));
    }
    if (uiFramework === "material") {
        return exports.beforeAfter(React.createElement(core_2.Grid, __assign({ container: true }, p, { style: style }), props.children));
    }
    return exports.beforeAfter(React.createElement("div", __assign({}, p, { className: AmplifyUI.sectionFooter, style: style }), props.children));
};
exports.SectionFooterPrimaryContent = function (props) {
    var uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.sectionFooterPrimaryContent);
    if (uiFramework === "bootstrap") {
        return exports.beforeAfter(React.createElement(reactstrap_1.Col, { xs: "12", style: style }, props.children));
    }
    if (uiFramework === "material") {
        return exports.beforeAfter(React.createElement(core_2.Grid, { item: true, xs: 12, style: style }, props.children));
    }
    return exports.beforeAfter(React.createElement("span", { className: AmplifyUI.sectionFooterPrimaryContent, style: style }, props.children));
};
exports.SectionFooterSecondaryContent = function (props) {
    var uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var align = props.align || "left";
    var style = exports.propStyle(props, theme.sectionFooterSecondaryContent);
    if (uiFramework === "bootstrap") {
        style["textAlign"] = align;
        return exports.beforeAfter(React.createElement(reactstrap_1.Col, { xs: "6", style: style }, props.children));
    }
    if (uiFramework === "material") {
        style["textAlign"] = align;
        return exports.beforeAfter(React.createElement(core_2.Grid, { item: true, xs: 6, style: style }, props.children));
    }
    return exports.beforeAfter(React.createElement("span", { className: AmplifyUI.sectionFooterSecondaryContent, style: style }, props.children));
};
exports.SectionBody = function (props) {
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.sectionBody);
    var p = core_1.JS.objectLessAttributes(props, ['theme', 'uiFramework', 'hideLogo']);
    return exports.beforeAfter(React.createElement("div", __assign({}, p, { className: AmplifyUI.sectionBody, style: style }), props.children));
};
exports.ActionRow = function (props) {
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.actionRow);
    var p = core_1.JS.objectLessAttributes(props, 'theme');
    return exports.beforeAfter(React.createElement("div", __assign({}, p, { className: "amplify-action-row", style: style }), props.children));
};
exports.Strike = function (props) {
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.strike);
    return exports.beforeAfter(React.createElement("div", { className: AmplifyUI.strike, style: style },
        React.createElement(exports.StrikeContent, { theme: theme }, props.children)));
};
exports.StrikeContent = function (props) {
    var theme = props.theme || Amplify_UI_Theme_1.default;
    return exports.beforeAfter(React.createElement("span", { className: AmplifyUI.strikeContent, style: theme.strikeContent }, props.children));
};
exports.FormRow = function (props) {
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.formRow);
    var p = core_1.JS.objectLessAttributes(props, 'theme');
    return exports.beforeAfter(React.createElement("div", __assign({}, p, { className: AmplifyUI.formRow, style: style }), props.children));
};
exports.RadioRow = function (props) {
    var id = props.id || '_' + props.value;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    return (React.createElement(exports.FormRow, { theme: theme },
        React.createElement(exports.Radio, __assign({}, props, { id: id })),
        React.createElement(exports.Label, { htmlFor: id, theme: theme }, props.placeholder)));
};
exports.Radio = function (props) {
    var uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.radio);
    var removeProps = ['theme', 'uiFramework', 'hideLogo'];
    var p = {};
    if (uiFramework === "material") {
        removeProps.push('size', 'block');
    }
    p = core_1.JS.objectLessAttributes(props, removeProps);
    return exports.beforeAfter(React.createElement("input", __assign({}, p, { type: "radio", className: AmplifyUI.radio, style: style })));
};
exports.CheckboxRow = function (props) {
    var theme = props.theme || Amplify_UI_Theme_1.default;
    return (React.createElement(exports.FormRow, { theme: theme },
        React.createElement(exports.Checkbox, __assign({}, props)),
        ' ',
        React.createElement(exports.Label, { htmlFor: props.placeholder, theme: theme }, props.label)));
};
exports.Checkbox = function (props) {
    var uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.checkbox);
    var removeProps = ['theme', 'uiFramework', 'hideLogo'];
    var p = {};
    if (uiFramework === "material") {
        removeProps.push('size', 'block');
    }
    p = core_1.JS.objectLessAttributes(props, removeProps);
    return exports.beforeAfter(React.createElement("input", __assign({}, p, { type: "checkbox", className: AmplifyUI.checkbox, style: style })));
};
exports.InputRow = function (props) {
    var uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.input);
    var removeProps = ['theme', 'uiFramework', 'hideLogo'];
    var p = {};
    if (uiFramework === "material") {
        removeProps.push('size', 'block');
    }
    p = core_1.JS.objectLessAttributes(props, removeProps);
    return (React.createElement(exports.FormRow, { theme: theme }, exports.beforeAfter(React.createElement("input", __assign({}, p, { className: AmplifyUI.input, style: style })))));
};
exports.Input = function (props) {
    var uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.input);
    var removeProps = ['theme', 'uiFramework', 'hideLogo'];
    var p = {};
    if (uiFramework === "material") {
        removeProps.push('size', 'block');
    }
    p = core_1.JS.objectLessAttributes(props, removeProps);
    if (uiFramework === "bootstrap") {
        return (React.createElement(React.Fragment, null,
            props.label && React.createElement(exports.InputLabel, { uiFramework: uiFramework }, props.label),
            React.createElement(reactstrap_1.Input, __assign({}, p, { size: "lg", style: style }))));
    }
    if (uiFramework === "material") {
        return (React.createElement(core_2.TextField, __assign({}, p, { margin: "normal", variant: "outlined", fullWidth: true, style: style, label: props.label })));
    }
    return (React.createElement("input", __assign({}, p, { className: AmplifyUI.input, style: style })));
};
exports.SelectInput = function (props) {
    var uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.selectInput);
    style["display"] = "flex";
    if (uiFramework === "bootstrap") {
        return (React.createElement("div", { style: style }, props.children));
    }
    if (uiFramework === "material") {
        return (React.createElement("div", { style: style }, props.children));
    }
    return (React.createElement("div", { className: AmplifyUI.selectInput, style: style }, props.children));
};
exports.Select = function (props) {
    var uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var flexBasis = props.flexBasis;
    var style = exports.propStyle(props, theme.select);
    var removeProps = ['theme', 'uiFramework', 'hideLogo'];
    var p = {};
    if (uiFramework === "material") {
        removeProps.push('size', 'block');
    }
    p = core_1.JS.objectLessAttributes(props, removeProps);
    if (flexBasis) {
        style["flexBasis"] = flexBasis;
    }
    if (uiFramework === "bootstrap") {
        return (React.createElement(RSSelect, __assign({}, p, { size: "lg", style: style }), props.children));
    }
    if (uiFramework === "material") {
        style["marginTop"] = "16px";
        style["marginBottom"] = "8px";
        return (React.createElement(MUSelect, __assign({}, p, { style: style }), props.children));
    }
    return (React.createElement("select", __assign({}, p, { className: AmplifyUI.select, style: style }), props.children));
};
exports.MultiSelect = function (props) {
    var uiFramework = props.uiFramework;
    var removeProps = ['theme', 'uiFramework', 'hideLogo'];
    var p = {};
    if (uiFramework === "material") {
        removeProps.push('size', 'block');
    }
    p = core_1.JS.objectLessAttributes(props, removeProps);
    return (React.createElement(react_select_1.default, __assign({}, p)));
};
exports.FormField = function (props) {
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.formField);
    var p = core_1.JS.objectLessAttributes(props, ['theme', 'uiFramework', 'hideLogo']);
    return exports.beforeAfter(React.createElement("div", __assign({}, p, { className: AmplifyUI.formField, style: style }), props.children));
};
exports.Button = function (props) {
    var uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.button);
    var disabled = props.disabled || false;
    var removeProps = ['theme', 'uiFramework', 'hideLogo'];
    var p = __assign(__assign({}, props), { block: props.block ? "true" : "false" });
    if (uiFramework === "material") {
        removeProps.push('size', 'block');
    }
    p = core_1.JS.objectLessAttributes(props, removeProps);
    if (uiFramework === "bootstrap") {
        return (React.createElement(reactstrap_1.Button, __assign({}, p, { style: style })));
    }
    if (uiFramework === "material") {
        return (React.createElement(core_2.Button, __assign({}, p, { style: style })));
    }
    return exports.beforeAfter(React.createElement("button", __assign({}, p, { className: AmplifyUI.button, style: style, disabled: disabled }), props.children));
};
exports.PhotoPickerButton = function (props) {
    var uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.photoPickerButton);
    var removeProps = ['theme', 'uiFramework', 'hideLogo'];
    var p = {};
    if (uiFramework === "material") {
        removeProps.push('size', 'block');
    }
    p = core_1.JS.objectLessAttributes(props, removeProps);
    return (React.createElement("button", __assign({}, p, { className: [AmplifyUI.photoPickerButton, AmplifyUI.button].join(' '), style: style }), props.children));
};
exports.SignInButton = function (props) {
    var uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var styles = Object.assign({}, theme.signInButton, theme[props.variant]);
    var removeProps = ['theme', 'uiFramework', 'hideLogo'];
    var p = {};
    if (uiFramework === "material") {
        removeProps.push('size', 'block');
    }
    p = core_1.JS.objectLessAttributes(props, removeProps);
    return exports.beforeAfter(React.createElement("button", __assign({}, p, { className: AmplifyUI.signInButton, style: styles }), props.children));
};
exports.SignInButtonIcon = function (props) {
    var uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.signInButtonIcon);
    var removeProps = ['theme', 'uiFramework', 'hideLogo'];
    var p = {};
    if (uiFramework === "material") {
        removeProps.push('size', 'block');
    }
    p = core_1.JS.objectLessAttributes(props, removeProps);
    return exports.beforeAfter(React.createElement("span", __assign({}, p, { className: AmplifyUI.signInButtonIcon, style: style }), props.children));
};
exports.SignInButtonContent = function (props) {
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.signInButtonContent);
    return exports.beforeAfter(React.createElement("span", { className: AmplifyUI.signInButtonContent, style: style }, props.children));
};
exports.Link = function (props) {
    var uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.a);
    var removeProps = ['theme', 'uiFramework', 'hideLogo'];
    var p = {};
    if (uiFramework === "material") {
        removeProps.push('size', 'block');
    }
    p = core_1.JS.objectLessAttributes(props, removeProps);
    if (uiFramework === "bootstrap") {
        return exports.beforeAfter(React.createElement(reactstrap_1.Button, __assign({ color: "link" }, p, { style: style }), props.children));
    }
    if (uiFramework === "material") {
        return exports.beforeAfter(React.createElement(core_2.Button, __assign({}, p, { style: style }), props.children));
    }
    return exports.beforeAfter(React.createElement("a", __assign({}, p, { className: AmplifyUI.a, style: style }), props.children));
};
exports.Label = function (props) {
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.label);
    return exports.beforeAfter(React.createElement("label", __assign({}, p, { className: AmplifyUI.label, style: style }), props.children));
};
exports.Hint = function (props) {
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.hint);
    return exports.beforeAfter(React.createElement("div", { className: AmplifyUI.hint, style: style }, props.children));
};
exports.InputLabel = function (props) {
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.inputLabel);
    return exports.beforeAfter(React.createElement("div", { className: AmplifyUI.inputLabel, style: style }, props.children));
};
exports.NavBar = function (props) {
    var uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.navBar);
    var removeProps = ['theme', 'uiFramework', 'hideLogo'];
    var p = {};
    if (uiFramework === "material") {
        removeProps.push('size', 'block');
    }
    p = core_1.JS.objectLessAttributes(props, removeProps);
    return exports.beforeAfter(React.createElement("div", __assign({}, p, { className: AmplifyUI.navBar, style: style }), props.children));
};
exports.Nav = function (props) {
    var uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.nav);
    var removeProps = ['theme', 'uiFramework', 'hideLogo'];
    var p = {};
    if (uiFramework === "material") {
        removeProps.push('size', 'block');
    }
    p = core_1.JS.objectLessAttributes(props, removeProps);
    return exports.beforeAfter(React.createElement("div", __assign({}, p, { className: AmplifyUI.nav, style: style }), props.children));
};
exports.NavRight = function (props) {
    var uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.navRight);
    var removeProps = ['theme', 'uiFramework', 'hideLogo'];
    var p = {};
    if (uiFramework === "material") {
        removeProps.push('size', 'block');
    }
    p = core_1.JS.objectLessAttributes(props, removeProps);
    return exports.beforeAfter(React.createElement("div", __assign({}, p, { className: AmplifyUI.navRight, style: style }), props.children));
};
exports.NavItem = function (props) {
    var uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.navItem);
    var removeProps = ['theme', 'uiFramework', 'hideLogo'];
    var p = {};
    if (uiFramework === "material") {
        removeProps.push('size', 'block');
    }
    p = core_1.JS.objectLessAttributes(props, removeProps);
    return exports.beforeAfter(React.createElement("div", __assign({}, p, { className: AmplifyUI.navItem, style: style }), props.children));
};
exports.NavButton = function (props) {
    var uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.navButton);
    var removeProps = ['theme', 'uiFramework', 'hideLogo'];
    var p = {};
    if (uiFramework === "material") {
        removeProps.push('size', 'block');
    }
    p = core_1.JS.objectLessAttributes(props, removeProps);
    return exports.beforeAfter(React.createElement("button", __assign({}, p, { className: AmplifyUI.button, style: style }), exports.beforeAfter(React.createElement("span", null, props.children))));
};
exports.Toast = function (props) {
    var onClose = props.onClose, uiFramework = props.uiFramework;
    var theme = props.theme || Amplify_UI_Theme_1.default;
    if (uiFramework === "material") {
        return exports.beforeAfter(React.createElement(MUToast, { open: true, onClose: onClose, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
            }, message: props.children }));
    }
    return (React.createElement("div", __assign({}, props, { theme: theme, className: AmplifyUI.toast, style: theme.toast }),
        React.createElement("span", null, props.children),
        React.createElement("a", { className: AmplifyUI.toastClose, onClick: onClose })));
};
exports.Toast.defaultProps = {
    onClose: function () { return void (0); }
};
exports.PhotoPlaceholder = function (props) {
    var theme = props.theme || Amplify_UI_Theme_1.default;
    var style = exports.propStyle(props, theme.photoPlaceholder);
    return (React.createElement("div", { className: AmplifyUI.photoPlaceholder, style: style },
        React.createElement("div", { className: AmplifyUI.photoPlaceholderIcon },
            React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '64', height: '64', viewBox: '0 0 24 24' },
                React.createElement("circle", { cx: '12', cy: '12', r: '3.2' }),
                React.createElement("path", { d: 'M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z' }),
                React.createElement("path", { d: 'M0 0h24v24H0z', fill: 'none' })))));
};
exports.beforeAfter = function (el) {
    var style = el.props.style || {};
    var before = style.before, after = style.after;
    if (!before && !after) {
        return el;
    }
    return (React.createElement("span", { style: { position: 'relative' } },
        before ? React.createElement("span", { style: before }, before.content) : null,
        el,
        after ? React.createElement("span", { style: after }, after.content) : null));
};
exports.propStyle = function (props, themeStyle) {
    var id = props.id, style = props.style;
    var styl = Object.assign({}, style, themeStyle);
    if (!id) {
        return styl;
    }
    var selector = '#' + id;
    Object.assign(styl, styl[selector]);
    return styl;
};
//# sourceMappingURL=Amplify-UI-Components-React.js.map